import React from 'react';

interface Props {
  htmlId: string;
  toggleAction: (value: boolean) => void;
  checked: boolean;
  disabled?: boolean;
}

const ToggleButton: React.FC<Props> = ({ htmlId, toggleAction, checked, disabled = false }) => {
  const change = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    toggleAction(!checked);
    e.preventDefault();
  };
  return (
    <div className="toggle-btn">
      <input
        id={htmlId}
        className="toggle-btn__input"
        type="checkbox"
        onChange={() => {}}
        checked={checked}
        disabled={disabled}
      />
      <button type="button" className="toggle-btn__input-label" onClick={change}>
        Toggle
      </button>
    </div>
  );
};

export default ToggleButton;
